import {Arr, Num, Obj, OptNum, OptStr, Str} from '@repo/shared/api/core/api_schema';
import type {SchemaToType} from '@repo/shared/api/core/api_schema';

// A movie identity does not require a known NZB release or an IMDb mapping.
export const IdentifiedMovieSchema = Obj({
  tmdbId: Num(),
  imdbId: OptStr(),
  title: Str(),
  originalTitle: OptStr(),
  year: OptStr(),
  overview: Str(),
  posterPath: OptStr(),
  runtimeMinutes: OptNum(),
  rating: OptNum(),
});
export type IdentifiedMovie = SchemaToType<typeof IdentifiedMovieSchema>;

export const MOVIE_IDENTIFICATION_API = {
  '/catalogue/identify/search': {
    POST: {
      req: Obj({query: Str(), year: OptStr(), page: OptNum()}),
      res: Obj({movies: Arr(IdentifiedMovieSchema), page: Num(), totalPages: Num()}),
    },
  },
  '/catalogue/identify/movie': {
    POST: {req: Obj({tmdbId: Num()}), res: Obj({movie: IdentifiedMovieSchema})},
  },
};

export function isIdentifiedMovie(value: unknown): value is IdentifiedMovie {
  if (!value || typeof value !== 'object') return false;
  const movie = value as Record<string, unknown>;
  return (
    Number.isSafeInteger(movie['tmdbId']) &&
    Number(movie['tmdbId']) > 0 &&
    typeof movie['title'] === 'string' &&
    movie['title'].trim().length > 0 &&
    movie['title'].length <= 240 &&
    typeof movie['overview'] === 'string' &&
    movie['overview'].length <= 3000 &&
    (movie['imdbId'] === undefined ||
      (typeof movie['imdbId'] === 'string' && /^\d{7,10}$/u.test(movie['imdbId']))) &&
    (movie['originalTitle'] === undefined ||
      (typeof movie['originalTitle'] === 'string' && movie['originalTitle'].length <= 240)) &&
    (movie['year'] === undefined ||
      (typeof movie['year'] === 'string' && /^(19|20)\d{2}$/u.test(movie['year']))) &&
    (movie['posterPath'] === undefined ||
      (typeof movie['posterPath'] === 'string' &&
        /^\/[a-zA-Z0-9_.-]+\.(jpg|png)$/u.test(movie['posterPath']))) &&
    ['runtimeMinutes', 'rating'].every(
      key =>
        movie[key] === undefined ||
        (typeof movie[key] === 'number' &&
          Number.isFinite(movie[key]) &&
          movie[key] >= 0 &&
          movie[key] <= (key === 'rating' ? 10 : 1440)),
    )
  );
}
